import { ZipCodeEntityMock } from '@vlaio/shared/ui/forms';

import { PartialCompanySearchEntity } from '../interfaces';

export const CompanyFiltersEntityMock: PartialCompanySearchEntity = {
	searchQuery: 'Kastart',
	zipCode: ZipCodeEntityMock
};
